<template>
    <div class="row" style="display: flex;flex-wrap: wrap;margin-right: -15px;margin-left: -15px;">
        <div class="flex lg1 mg1"></div>
        <v-card style="margin: 5px" class="flex lg3 mg3">

            <div class="m-portlet">
                <div class="m-portlet__head">
                    <div class="m-portlet__head-caption">
                        <div>
                            <h3 class="m-portlet__head-text" style="float: initial;text-align: start;padding: 30px;">
                                Index
                            </h3>
                        </div>
                    </div>
                </div>


                <div class="m-portlet__body flex lg3 mg3" style="padding-top: 15px; padding-bottom: 15px;position: fixed">

                    <div class="m-section m-section--last">
                        <div class="m-section__content">
                            <div class="m-demo">
                                <div class="m-demo__preview" style="padding: 15px;">
                                    <div class="m-list-search">
                                        <div class="m-list-search__results">

                                        <span class="m-list-search__result-category m-list-search__result-category--first">
                                            <span>Methods</span>
                                        </span>
                                            <a v-for="(value, key) in methods" :href="'/#/documentation#method-count-'+key" class="m-list-search__result-item">
                                                <span class="m-list-search__result-item-text"><strong>{{value.verb}}</strong> {{value.url}}</span>
                                            </a>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

        </v-card>


        <div  class="flex lg7 mg7">

            <div class="row">

                <div class="col-lg-12">

                    <v-card v-for="(value, key) in methods" class="m-portlet">
                        <a :id="'method-count-'+key" style="display: block; position: relative; top: -75px; visibility: hidden;"></a>
                        <div class="m-portlet__head">
                            <div class="m-portlet__head-caption">
                                <div class="m-portlet__head-title">
                                    <h3 class="m-portlet__head-text">
                                        <span :class="'m-badge m-badge--'+getColor(value.verb) +' m-badge--wide'">{{value.verb}}</span>
                                        <span>{{value.url}}</span>
                                        <!--<i style="margin-left:5px; margin-right:5px;" class="fa fa-arrow-right"></i>-->
                                        <!--<span><%- method.name %></span>-->
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <div class="m-portlet__body" style="padding-top: 15px; padding-bottom: 15px;">

                            <div class="m-section">
                                <h3 class="m-section__heading">
                                    Description
                                </h3>
                                <div class="m-section__content">
                                    <span>{{value.description}}</span>
                                </div>
                            </div>

                            <div class="m-section">
                                <h3 class="m-section__heading">
                                    Input
                                </h3>
                                <div class="m-section__content">
                                    <div class="m-demo">
                                        <div class="m-demo__preview" style="padding: 15px;">
                                            <div class="m-list-search">
                                                <div class="m-list-search__results">

                                                <span class="m-list-search__result-category m-list-search__result-category--first">
                                                    <span>Headers</span>
                                                </span>
                                                    <span v-if="value.auth" class="m-list-search__result-item">
                                                        <strong>Authorization</strong>: Bearer LOGIN_TOKEN
                                                    </span>

                                                    <span v-if="value.type" class="m-list-search__result-item">
                                                        <strong>Content-Type</strong>: {{value.type}}
                                                    </span>

                                                    <span v-if="value.in.length > 0">
                                                        <span class="m-list-search__result-category">
                                                            <span>Parameters</span>
                                                        </span>
                                                        <span v-if="value.preIn" class="m-list-search__result-item">
                                                            <span>* {{value.preIn}}</span>
                                                        </span>

                                                        <span v-for="(valueIN, keyIN) in value.in" class="m-list-search__result-item">
                                                            <strong>{{valueIN.name}}</strong> ({{valueIN.type}}): {{valueIN.description}}
                                                        </span>

                                                        <span v-if="value.postIn" class="m-list-search__result-item">
                                                            <span>* {{value.postIn}}</span>
                                                        </span>
                                                    </span>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="m-section m-section--last">
                                <h3 class="m-section__heading">
                                    Output
                                </h3>
                                <div class="m-section__content">
                                    <div class="m-demo">
                                        <div class="m-demo__preview" style="padding: 15px;">
                                            <div class="m-list-search">
                                                <div class="m-list-search__results">
                                                    <span v-for="(valueOUT, keyOUT) in value.out">
                                                        <span class="m-list-search__result-category m-list-search__result-category">
                                                            <span>Status {{valueOUT.status}}</span>
                                                        </span>
                                                            <span class="m-list-search__result-item" v-for="(valuePAR, keyPAR) in valueOUT.params">
                                                                <strong>{{valuePAR.name}}</strong> ({{valuePAR.type}}): {{valuePAR.description}}
                                                            </span>
                                                    </span>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </v-card>

                </div>

            </div>

        </div>
    </div>
</template>

<script>
    import {  VIcon, VFlex, VCard, VBtn ,VTextField,VTextarea } from 'vuetify/lib';
    export default {
        name: "Documentation",
        components: {
            VIcon,
                VFlex,
                VCard,
                VBtn,
                VTextField,
                VTextarea
        },
        data: () => ({
            methods: [
                {
                    "name": "SignUp",
                    "url": "/api/signup",
                    "verb": "POST",
                    "description": "Sign up and login in the platform. If success, returns a Bearer Token.",
                    "type": "application/x-www-form-urlencoded",
                    "auth": false,
                    "in": [{
                        "type": "text",
                        "name": "email",
                        "description": "The user email"
                    },{
                        "type": "text",
                        "name": "password",
                        "description": "The user password"
                    },{
                        "type": "text",
                        "name": "name",
                        "description": "The user name"
                    },{
                        "type": "text",
                        "name": "privateKey",
                        "description": "(Optional) The user private key. by default, it will be randomly generated."
                    }],
                    "out": [{
                        "status": 200,
                        "params": [{
                            "type": "text",
                            "name": "token",
                            "description": "If status is true, the user authorization token"
                        }, {
                            "type": "text",
                            "name": "email",
                            "description": "If status is true, the user email"
                        }]
                    }, {
                        "status": 400,
                        "params": [{
                            "type": "text",
                            "name": "message",
                            "description": "The error message"
                        }]
                    }]
                },

                {
                    "name": "LogIn",
                    "url": "/api/login",
                    "verb": "POST",
                    "description": "Authentificate in the platform and returns a Bearer Token.",
                    "type": "application/x-www-form-urlencoded",
                    "auth": false,
                    "in": [{
                        "type": "text",
                        "name": "email",
                        "description": "The user email"
                    },
                        {
                            "type": "text",
                            "name": "password",
                            "description": "The user password"
                        }
                    ],
                    "out": [{
                        "status": 200,
                        "params": [{
                            "type": "text",
                            "name": "token",
                            "description": "If status is true, the user authorization token"
                        }, {
                            "type": "text",
                            "name": "email",
                            "description": "If status is true, the user email"
                        }]
                    }, {
                        "status": 400,
                        "params": [{
                            "type": "text",
                            "name": "message",
                            "description": "The error message"
                        }]
                    }]
                },

                {
                    "name": "Get Files",
                    "url": "/api/list/files",
                    "verb": "GET",
                    "description": "List all yours files.",
                    "in": [
                        {
                            "type": "text",
                            "name": "dir",
                            "description": "(Optional) The parent directory id. Default is set to root directory."
                        }, {
                            "type": "integer",
                            "name": "page",
                            "description": "(Optional) The page number. Default set to 0 (first page)."
                        }, {
                            "type": "integer",
                            "name": "limit",
                            "description": "(Optional) The maximum files per page. Default set to 7."
                        }, {
                            "type": "text",
                            "name": "search",
                            "description": "(Optional) The search string. If not empty it will search for matching file names. Default empty."
                        }, {
                            "type": "archived",
                            "name": "boolean",
                            "description": "(Optional) If true, it will include archived files. Default set to false."
                        }
                    ],
                    "out": [{
                        "status": 200,
                        "params": [{
                            "type": "list",
                            "name": "items",
                            "description": "The items list"
                        }, {
                            "type": "object",
                            "name": "parent",
                            "description": "The parent folder object or empty if it is the root."
                        }, {
                            "type": "object",
                            "name": "pagination",
                            "description": "The pagination information."
                        }]
                    }, {
                        "status": 400,
                        "params": [{
                            "type": "text",
                            "name": "message",
                            "description": "The error message"
                        }]
                    }]
                },

                {
                    "name": "Upload Files",
                    "url": "/api/files",
                    "verb": "POST",
                    "description": "Uploads multiple files to the system",
                    "in": [{
                        "type": "[file]",
                        "name": "files",
                        "description": "The files to upload"
                    }, {
                        "type": "text",
                        "name": "parentFolder",
                        "description": "(Optional) The parent folder id. By default is the root folder."
                    }],
                    "out": [{
                        "status": 200,
                        "params": [{
                            "type": "text",
                            "name": "hashes",
                            "description": "The list of all encrypted file hashes"
                        }]
                    }, {
                        "status": 400,
                        "params": [{
                            "type": "text",
                            "name": "message",
                            "description": "The error message"
                        },{
                            "type": "list",
                            "name": "errors",
                            "description": "(Optional) If there are multiple errors, these are the errors."
                        }]
                    }]
                },

                {
                    "name": "Edit File",
                    "url": "/api/files/:hash",
                    "verb": "PUT",
                    "description": "Edits a file",
                    "in": [{
                        "type": "file",
                        "name": "file",
                        "description": "The edited file"
                    }, {
                        "type": "query",
                        "name": "hash",
                        "description": "The old hash file"
                    }],
                    "out": [{
                        "status": 200,
                        "params": [{
                            "type": "text",
                            "name": "hash",
                            "description": "The new file hash"
                        }]
                    }, {
                        "status": 400,
                        "params": [{
                            "type": "text",
                            "name": "message",
                            "description": "The error message"
                        }]
                    }]
                },

                {
                    "name": "Download File",
                    "url": "/api/files/:hash",
                    "verb": "GET",
                    "description": "Downloads a file",
                    "in": [{
                        "type": "query",
                        "name": "hash",
                        "description": "The encrypted file hash"
                    }],
                    "out": [{
                        "status": 200,
                        "params": [{
                            "type": "file",
                            "name": "file",
                            "description": "The decrypted file"
                        }]
                    }, {
                        "status": 400,
                        "params": [{
                            "type": "text",
                            "name": "message",
                            "description": "The error message"
                        }]
                    }]
                },

                {
                    "name": "Archive File",
                    "url": "/api/archive/:hash",
                    "verb": "POST",
                    "description": "Set a file as archived",
                    "in": [{
                        "type": "query",
                        "name": "hash",
                        "description": "The encrypted file hash"
                    }],
                    "out": [{
                        "status": 200,
                        "params": [{
                            "type": "boolean",
                            "name": "status",
                            "description": "The result of archiving file"
                        }]
                    }, {
                        "status": 400,
                        "params": [{
                            "type": "text",
                            "name": "message",
                            "description": "The error message"
                        }]
                    }]
                },

                {
                    "name": "Unarchive File",
                    "url": "/api/unarchive/:hash",
                    "verb": "POST",
                    "description": "Set a file as unarchived",
                    "in": [{
                        "type": "query",
                        "name": "hash",
                        "description": "The encrypted file hash"
                    }],
                    "out": [{
                        "status": 200,
                        "params": [{
                            "type": "boolean",
                            "name": "status",
                            "description": "The result of archiving file"
                        }]
                    }, {
                        "status": 400,
                        "params": [{
                            "type": "text",
                            "name": "message",
                            "description": "The error message"
                        }]
                    }]
                },

                {
                    "name": "Audit File",
                    "url": "/api/files/audit",
                    "verb": "POST",
                    "description": "Check if a file already exists in the system.",
                    "in": [{
                        "type": "file",
                        "name": "file",
                        "description": "The file to audit"
                    }],
                    "out": [{
                        "status": 200,
                        "params": [{
                            "type": "boolean",
                            "name": "exists",
                            "description": "True if the file exists in the system"
                        }, {
                            "type": "text",
                            "name": "hash",
                            "description": "True file hash if exists"
                        }, {
                            "type": "text",
                            "name": "name",
                            "description": "The file name if exists"
                        }]
                    }, {
                        "status": 400,
                        "params": [{
                            "type": "text",
                            "name": "message",
                            "description": "The error message"
                        }]
                    }]
                },

                {
                    "name": "Give acces to file",
                    "url": "/api/files/access",
                    "verb": "POST",
                    "description": "Give acces to the file to a user's specific public key.",
                    "type": "application/x-www-form-urlencoded",
                    "in": [{
                        "type": "text",
                        "name": "hashes",
                        "description": "The list of file hashes separated by ;"
                    },{
                        "type": "text",
                        "name": "userkey",
                        "description": "The encrypted file hash"
                    },{
                        "type": "integer",
                        "name": "permission",
                        "description": "The permission type"
                    }],
                    "out": [{
                        "status": 200,
                        "params": [{
                            "type": "boolean",
                            "name": "status",
                            "description": "True if the the access is successfully granted"
                        }]
                    }, {
                        "status": 400,
                        "params": [{
                            "type": "text",
                            "name": "message",
                            "description": "The error message"
                        },{
                            "type": "list",
                            "name": "errors",
                            "description": "(Optional) If there are multiple errors, these are the errors."
                        }]
                    }]
                },

                {
                    "name": "Remove acces to file",
                    "url": "/api/files/access",
                    "verb": "DELETE",
                    "description": "Remove acces to the file to a user's specific address.",
                    "type": "application/x-www-form-urlencoded",
                    "in": [{
                        "type": "text",
                        "name": "hash",
                        "description": "The encrypted file hash"
                    },{
                        "type": "text",
                        "name": "user",
                        "description": "The user address"
                    }],
                    "out": [{
                        "status": 200,
                        "params": [{
                            "type": "boolean",
                            "name": "status",
                            "description": "True if the the access is successfully granted"
                        }]
                    }, {
                        "status": 400,
                        "params": [{
                            "type": "text",
                            "name": "message",
                            "description": "The error message"
                        }]
                    }]
                },

                {
                    "name": "User Details",
                    "url": "/api/user/details",
                    "verb": "POST",
                    "description": "Get the user details from address, publicKey or email",
                    "type": "application/x-www-form-urlencoded",
                    "in": [{
                        "type": "text",
                        "name": "email",
                        "description": "The user email"
                    }, {
                        "type": "text",
                        "name": "address",
                        "description": "The user address"
                    }, {
                        "type": "text",
                        "name": "publicKey",
                        "description": "The user public key"
                    }],
                    "preIn": "It must be only one parameter from the list:",
                    "out": [{
                        "status": 200,
                        "params": [{
                            "type": "text",
                            "name": "address",
                            "description": "The user address"
                        }, {
                            "type": "text",
                            "name": "publicKey",
                            "description": "The user public key"
                        }, {
                            "type": "text",
                            "name": "email",
                            "description": "The user email"
                        }, {
                            "type": "text",
                            "name": "name",
                            "description": "The user name"
                        }]
                    }, {
                        "status": 400,
                        "params": [{
                            "type": "text",
                            "name": "message",
                            "description": "The error message"
                        }]
                    }]
                },

                {
                    "name": "File Info",
                    "url": "/api/files/:hash/info",
                    "verb": "Get",
                    "description": "Get the file info by hash",
                    "in": [{
                        "type": "query",
                        "name": "hash",
                        "description": "The encrypted file hash"
                    }],
                    "out": [{
                        "status": 200,
                        "params": [{
                            "type": "object",
                            "name": "file",
                            "description": "The file object"
                        }]
                    }, {
                        "status": 400,
                        "params": [{
                            "type": "text",
                            "name": "message",
                            "description": "The error message"
                        }]
                    }]
                },

                {
                    "name": "Get Comments",
                    "url": "/api/comments/:hash",
                    "verb": "Get",
                    "description": "Gets the file comments",
                    "in": [{
                        "type": "query",
                        "name": "hash",
                        "description": "The encrypted file hash"
                    }],
                    "out": [{
                        "status": 200,
                        "params": [{
                            "type": "object",
                            "name": "comments",
                            "description": "The comments object"
                        }]
                    }, {
                        "status": 400,
                        "params": [{
                            "type": "text",
                            "name": "message",
                            "description": "The error message"
                        }]
                    }]
                },

                {
                    "name": "Create a Comment",
                    "url": "/api/comments/",
                    "verb": "POST",
                    "description": "Create a new comment to a file",
                    "type": "application/x-www-form-urlencoded",
                    "in": [{
                        "type": "text",
                        "name": "hash",
                        "description": "The associated encrypted file hash"
                    }, {
                        "type": "text",
                        "name": "text",
                        "description": "The comment text"
                    }],
                    "out": [{
                        "status": 200,
                        "params": [{
                            "type": "boolean",
                            "name": "status",
                            "description": "The comment save status"
                        }]
                    }, {
                        "status": 400,
                        "params": [{
                            "type": "text",
                            "name": "message",
                            "description": "The error message"
                        }]
                    }]
                },

                {
                    "name": "Creates a Folder",
                    "url": "/api/folders",
                    "verb": "POST",
                    "description": "Creates a folder",
                    "type": "application/x-www-form-urlencoded",
                    "in": [{
                        "type": "text",
                        "name": "folderName",
                        "description": "The folder name"
                    },{
                        "type": "text",
                        "name": "parentFolder",
                        "description": "The parent folder ID"
                    }],
                    "out": [{
                        "status": 200,
                        "params": [{
                            "type": "boolean",
                            "name": "status",
                            "description": "The creation folder status"
                        }]
                    }, {
                        "status": 400,
                        "params": [{
                            "type": "text",
                            "name": "message",
                            "description": "The error message"
                        }]
                    }]
                },

                {
                    "name": "Change Directory",
                    "url": "/api/folders",
                    "verb": "POST",
                    "description": "Change the directory of a files list",
                    "type": "application/x-www-form-urlencoded",
                    "in": [{
                        "type": "list",
                        "name": "hashes",
                        "description": "The file hashes list separated by ';'"
                    },{
                        "type": "text",
                        "name": "directory",
                        "description": "The target directory ID"
                    }],
                    "out": [{
                        "status": 200,
                        "params": [{
                            "type": "boolean",
                            "name": "status",
                            "description": "The change directory operation status"
                        }]
                    }, {
                        "status": 400,
                        "params": [{
                            "type": "text",
                            "name": "message",
                            "description": "The error message"
                        },{
                            "type": "list",
                            "name": "errors",
                            "description": "(Optional) If there are multiple errors, these are the errors."
                        }]
                    }]
                },

            ]
        }),
        methods: {
            getColor(type) {
                var color='';
                if (type == "POST") color = "success";
                if (type == "DELETE") color = "danger";
                if (type == "GET") color = "info";
                if (type == "PUT") color = "warning";
                return color;
            }
        }
    }
</script>

<style scoped>
    .m-list-search__result-item-text{
        display: table-cell;
        height: 100%;
        width: 100%;
        vertical-align: middle;
        font-size: 1rem;
    }
    .m-portlet__head{
        border-bottom: 1px solid #ebedf2;
    }
    .m-demo .m-demo__preview {
        background: white;
        border: 4px solid #f7f7fa;
        padding: 30px;
        text-align: left;
    }
    .m-list-search .m-list-search__results .m-list-search__result-item .m-list-search__result-item-text {
        color: #7b7e8a;
    }

    .m-list-search .m-list-search__results .m-list-search__result-item .m-list-search__result-item-text {
        display: table-cell;
        height: 100%;
        width: 100%;
        vertical-align: middle;
        font-size: 1rem;
    }
    .m-list-search .m-list-search__results .m-list-search__result-item {
        display: table;
        table-layout: fixed;
        width: 100%;
        padding: 5px 0;
        outline: none;
    }
    .m-list-search .m-list-search__results .m-list-search__result-category {
        color: #716aca;
    }

    .m-list-search .m-list-search__results .m-list-search__result-category {
        display: block;
        font-weight: 600;
        font-size: 1rem;
        text-transform: uppercase;
    }
    .m-portlet.v-card.v-sheet.theme--light{
        margin: 10px;
    }
    .m-badge {
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        -ms-border-radius: 10px;
        -o-border-radius: 10px;
        border-radius: 10px;
        background: #eaeaea;
        color: #444;
        font-size: 0.8rem;
        line-height: 20px;
        min-height: 20px;
        min-width: 20px;
        vertical-align: middle;
        text-align: center;
        display: inline-block;
        padding: 0px 2px;
    }
    .m-badge.m-badge--success {
        background-color: #34bfa3;
        color: #ffffff;
    }
    .m-badge.m-badge--info {
        background-color: #36a3f7;
        color: #ffffff;
    }
    .m-badge.m-badge--warning {
        background-color: #ffb822;
        color: #111111;
    }
    .m-badge.m-badge--danger {
        background-color: #f4516c;
        color: #ffffff;
    }
    .m-portlet__head-caption {
        display: table;
        table-layout: fixed;
        vertical-align: middle;
        font-size: 1.3rem;
        font-weight: 500;
        height: 100%;
    }
    .m-portlet__head-title{
        height: 100%;
    }
    .m-portlet .m-portlet__head {
        display: table;
        width: 100%;
        padding: 0 2.2rem;
        height: 5.1rem;
    }
    .m-portlet__head-text{
        position: relative;
        top: 25%;
    }
    .m-badge.m-badge--wide {
        letter-spacing: 0.6px;
        padding: 1px 10px;
    }
    .m-portlet__body{
        text-align: left;
        padding-left: 30px;
    }
</style>